/**
 * Base Routes. Should be proceeded by a forward slash
 */
export const AppRoutes = {
    // Shared
    Home: '/',
    Users: '/users',
    Preferences: '/preferences',

    // Support
    Kiosks: '/kiosks',
    HealthCheck: '/health-checks',
    ResponseLog: '/response-logs',
    KioskBanners: '/kiosk-banners',
    DealerGroups: '/dealer-groups',
    DealerSettings: '/dealer-settings',
    FortellisSwapTables: '/fortellis-swap-tables',
    Reports: '/reports',
    SMSWhitelist: '/sms-whitelist',
    HunterVehicles: '/hunter-vehicles',
    Services: '/services',

    // Dashboard
    Summary: '/overview',
    Activity: '/activity',
    Help: '/help',
    Settings: '/settings',
    KeyManagement: '/keymanagement',
    QRCodeCheckIn: '/qrcodecheckin',
} as const;

/**
 * Subroutes. Should not be proceeded by a forward slash
 */
export const SummaryRoutes = {
    Dealers: 'dealers',
    Compare: 'compare',
    Brands: 'brands',
    Groups: 'groups',
    DMS: 'dms',
    Regions: 'regions',
} as const;

export const Dashboard_KeyManagementRoutes = {
    Express: 'express',
    The365: 'the365',
    Locker: ':lockerId',
    QrCode: 'qr-code',
} as const;

export const SettingsRoutes = {
    General: 'general',
    DisclaimersAndConsents: 'custommessages',
    Communications: 'communications',
} as const;

export const QRCodeScanRoutes = {
    Summary: 'summary',
    Scan: 'scan',
} as const;

export const UserRoutes = {
    Maintenance: 'maintenance',
    Add: 'add',
    Edit: 'edit',
} as const;

export const Support_ReportRoutes = {
    NotificationDeliveryStatus: 'notification-delivery-status',
    CheckInCompletion: 'check-in-completion',
    CheckInSelections: 'check-in-selections',
    Pickup: 'pickup',
} as const;

/**
 * Helper function to resolve a complete path name based on a combination of base routes and
 * subroutes as defined above
 *
 * IE navigate(PathName(AppRoutes.Summary, SummaryRoutes.Dealers))
 *
 * @param paths path to combine
 */
export const PathName = (...paths: string[]) => {
    return paths.join('/');
};